"use client";

import Slider from "react-slick";
import Section from "../Section";

import moritzGrumbach from "../../../../../public/images/graboxy/MoritzGrumbach.jpg";
import adamFeldmann from "../../../../../public/images/graboxy/AdamFeldmann.jpg";
import faridSingh from "../../../../../public/images/graboxy/FaridSingh.jpg";
import Quote from "./Quote";

import play from "./play.svg";
import Link from "next/link";

const SETTINGS = {
  dots: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
      },
    },
  ],
};

const Quotes = () => (
  <Section className="quote">
    <div className="container">
      <div className="row">
        <div className="col-12 text-center mb-3">
          <h1>What They Say About Us</h1>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <Slider {...SETTINGS} className="slider">
            <Quote
              img={moritzGrumbach}
              name="Moritz Grumbach"
              title="Founder & Managing Director"
              subtitle="Vertum.Group"
            >
              I had the pleasure of getting to know Cursor Insight and their
              product Graboxy in the course of the Cybernorth Accelerator. Not
              only has Graboxy been one of the very highlights of the program
              since its start, but also one of the few genius – and yet
              performing! – ideas that one wants to accompany, foster and boost
              just for its proper excellence.
            </Quote>

            <Quote
              img={adamFeldmann}
              name="Adam Feldmann"
              title="Head of Big Data Research Group"
              subtitle="University of Pecs"
            >
              The professional and approachable team behind Graboxy truly
              understands the scientific demands of cutting edge technology
              research. They designed and carried out high quality research
              projects and are clearly capable of commercializing the outcomes.
            </Quote>

            <Quote
              img={faridSingh}
              name="Farid Singh"
              title="CEO"
              subtitle="Take 3 Innovate"
            >
              Graboxy is changing how we think of digital sign-on and safety.
              Think simple, seamless and single device login, verification and
              anti fraud, in one service.
            </Quote>
          </Slider>
        </div>
      </div>
      <div className="row">
        <div className="col-12 mt-5 pt-3 text-center">
          <Link href="/#submit" className="btn">
            Book A Demo{" "}
            <img src={play.src} alt="Play icon" width={20} height={20} />
          </Link>
        </div>
      </div>
    </div>
  </Section>
);

export default Quotes;
